import { PortalWrapper } from 'app/App.styles';
import { Footer } from 'app/core/footer/Footer';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { Column, Layout, Row } from 'shared';

import { AdminTools } from './adminTools/AdminTools';
import { DashboardProps } from './Dashboard.types';
import { EndpointsContainer } from './endpoints/EndpointsContainer';
import { Header } from './header/Header';
import { ReportsContainer } from './reports/ReportsContainer';
import { SidebarContainer } from './sidebar/SidebarContainer';
import { TppsContainer } from './tpps/TppsContainer';

export const Dashboard = ({ logoutFunction, accountInfo }: DashboardProps) => {
  return (
    <Layout header={<Header userName={accountInfo.account.name} logoutFunction={logoutFunction} />} footer={<Footer />}>
      <Row height="100%">
        <Column>
          <PortalWrapper className="portal">
            <Row height="100%">
              <Column size={[12, 4, 4, 3]}>
                <SidebarContainer />
              </Column>

              <Column size={[12, 8, 8, 9]}>
                <Switch>
                  <Route path="/endpoints" component={EndpointsContainer} />
                  <Route path="/reports" component={ReportsContainer} />
                  <Route path="/tpps" component={TppsContainer} />
                  <Route path="/admin-tools" component={AdminTools} />
                  <Redirect to="/admin-tools" />
                </Switch>
              </Column>
            </Row>
          </PortalWrapper>
        </Column>
      </Row>
    </Layout>
  );
};
